<template>
    <section class="content">
        <div>
            <div class="box-body">
    
                <div v-if="updatehouseDetails" class="">
                    <div class="">
                        <div class="">
                            <div class="">
                            </div>
                            <div id="details" class="overlay">
                                <div class="overlay_inner">
                                    <div class="row form-modal">
                                        <h4 class="editHouse">Edit House Details</h4>
                                        <vue-form :state="formstate" class="formadd_scroll formadd_scroll_margin">
                                            <div class="col-sm-12">
                                                <div class="col-sm-6">
    
                                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.cityName)">
                                                        <label>City Name</label>
                                                        <input type="text" name="cityName" class="form-control" required readonly v-model="house.cityName" placeholder="City Name" />
                                                        <field-messages name="cityName" show="$touched || $submitted" class="form-control-feedback">
                                                            <div slot="required">City is a required field</div>
                                                        </field-messages>
                                                    </validate>
                                                </div>
    
                                                <div class="col-sm-6">
                                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.areaName)">
                                                        <label>Zone Name</label>
                                                        <input type="text" name="cityName" class="form-control" required readonly v-model="house.areaName" placeholder="Zone Name" />
                                                        <field-messages name="areaName" show="$touched || $submitted" class="form-control-feedback">
                                                            <div slot="required">Zone is a required field</div>
                                                        </field-messages>
                                                    </validate>
                                                </div>
                                            </div>
    
                                            <div class="col-sm-12">
                                                <div class="col-sm-6">
    
                                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.divisionName)">
                                                        <label>Division Name</label>
                                                        <input type="text" name="divisionName" class="form-control" required readonly v-model="house.divisionName" placeholder="Division Name" />
                                                        <field-messages name="divisionName" show="$touched || $submitted" class="form-control-feedback">
                                                            <div slot="required">Division Name is a required field</div>
                                                        </field-messages>
                                                    </validate>
                                                </div>
    
                                                <div class="col-sm-6">
                                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.areaName)">
                                                        <label>Line / Tower Name</label>
                                                        <input type="text" name="lineTowerName" class="form-control" required readonly v-model="house.lineTowerName" placeholder="Line / Tower Name" />
                                                        <field-messages name="lineTowerName" show="$touched || $submitted" class="form-control-feedback">
                                                            <div slot="required">Line / Tower Name is a required field</div>
                                                        </field-messages>
                                                    </validate>
                                                </div>
                                            </div>
    
                                            <div class="col-sm-12">
                                                <div class="col-sm-6">
    
                                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.hnNo)">
                                                        <label>House Number</label>
                                                        <input type="text" name="hnNo" class="form-control" required readonly v-model="house.hnNo" placeholder="House Number"  />
                                                        <field-messages name="hnNo" show="$touched || $submitted" class="form-control-feedback">
                                                            <div slot="required">House Number is a required field</div>
                                                        </field-messages>
                                                    </validate>
                                                </div>
    
                                                <div class="col-sm-6">
                                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.houseTypeId)">
                                                        <label>House Type</label>
                                                        <select required v-model="house.houseTypeId" name="houseTypeId" class="form-control">
                                                            <option value="" disabled>Select Type</option>
    
                                                            <option v-for="(type, index) in houseType" :key="index" :value="type._id">
                                                                {{ type.name }}
                                                            </option>
                                                        </select>
                                                        <field-messages name="houseTypeId" show="$touched || $submitted" class="form-control-feedback">
                                                            <div slot="required">house Type is a required field</div>
                                                        </field-messages>
                                                    </validate>
                                                </div>
                                            </div>
                                            <div class="col-sm-12">
                                                <div class="col-sm-6">
                                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.contactPerson)">
                                                        <label> Contact Person </label>
                                                        <input type="text" name="contactPerson" class="form-control" v-model="house.contactPerson" placeholder="Contact Person" pattern="^[a-zA-Z][a-zA-Z0-9\s]{0,25}[^\s]$" />
                                                        <field-messages name="contactPerson" show="$touched || $submitted" class="form-control-feedback validation_msg">
                                                            <div slot="pattern">
                                                                Alphabets/Numbers/Special Characters are allowed.
                                                            </div>
                                                        </field-messages>
                                                    </validate>
                                                </div>
                                                <div class="col-sm-6">
                                                    <validate auto-label class="form-group">
                                                        <label>Contact Number</label>
                                                        <input type="text" name="contact" class="form-control" v-model="house.contact" placeholder="Contact Number" pattern="[78965][0-9]{9}" />
                                                        <field-messages name="contact" show="$touched || $submitted" class="form-control-feedback">
                                                            <div slot="required">Contact Number is a required field</div>
                                                            <div slot="pattern">Contact Number is Invalid</div>
                                                        </field-messages>
                                                    </validate>
                                                </div>
                                            </div>
    
                                            <div class="col-sm-12">
                                                <div class="col-sm-6">
                                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.houseTag)">
                                                        <label> Tag </label>
                                                        <input maxlength="25" type="text" name="houseTag" class="form-control" v-model="house.houseTag" placeholder="Tag" pattern="^\S(.*\S)?$" />
                                                        <field-messages name="houseTag" show="$touched || $submitted" class="form-control-feedback validation_msg">
                                                            <div slot="pattern">
                                                                Alphabets/Numbers/Special Characters are allowed.
                                                            </div>
                                                        </field-messages>
                                                    </validate>
                                                </div>
                                                <div class="col-sm-6">
    
                                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.memberCount)">
                                                        <label>Family Members</label>
                                                        <input name="memberCount" class="form-control" required v-model="house.memberCount" placeholder="Family Members" />
                                                        <field-messages name="memberCount" show="$touched || $submitted" class="form-control-feedback">
                                                            <div slot="required">Family members is a required field</div>
                                                        </field-messages>
                                                    </validate>
                                                </div>
                                            </div>
    
                                            <div class="col-sm-12">
                                                <!-- <h4> Latitude </h4> -->
                                                <div class="col-sm-6">
                                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.Latitude)">
                                                        <label> Latitude </label>
                                                        <input type="text" name="latitude" class="form-control" required v-model="house.latitude" placeholder="latitude" />
                                                        <field-messages name="latitude" show="$touched || $submitted" class="form-control-feedback">
                                                            <div slot="required">
                                                                Latitude is a required field
                                                            </div>
                                                            <div slot="pattern">
                                                                Latitude must be valid and between -90 to 90
                                                            </div>
                                                        </field-messages>
                                                    </validate>
                                                </div>
                                                <div class="col-sm-6">
                                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.longitude)">
                                                        <label> Longitude </label>
                                                        <input type="text" name="longitude" class="form-control" required v-model="house.longitude" placeholder="Longitude" />
                                                        <field-messages name="longitude" show="$touched || $submitted" class="form-control-feedback">
                                                            <div slot="required">
                                                                Longitude is a required field
                                                            </div>
                                                            <div slot="pattern">
                                                                Latitude must be valid and between -180 to 180
                                                            </div>
                                                        </field-messages>
                                                    </validate>
                                                </div>
                                            </div>
    
                                            <div class="col-sm-12">
                                                <div class="col-sm-6">
                                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.status)">
                                                        <label>Survey Status</label>
                                                        <select required v-model="house.houseStatus" name="houseStatus" class="form-control">
                                                            <option value="" disabled> Select Status </option>
                                                            <option v-for="(status,index) in houseStatus" :key="index" :value="status">
                                                                {{status}}
                                                            </option>
                                                        </select>
                                                        <field-messages name="houseStatus" show="$touched || $submitted" class="form-control-feedback">
                                                            <div slot="required">Status is a required field</div>
                                                        </field-messages>
                                                    </validate>
                                                </div>
                                            </div>
    
                                        </vue-form>
                                        <div class="form-actions">
                                            <button @click="onClose" v-bind:class="'mr-5  btn btn-default'">
                                                Cancel
                                            </button>
                                            <button type="submit" @click="updateHouseInfo" :disabled="!(formstate.$dirty && formstate.$valid)" v-bind:class="'mr-2 btn gradientbt'">
                                                Update
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div v-if="isSingleMap" class="">
                    <div class="location">
                        <div id="details" class="overlay waste_type_pop">
                            <div class="overlay_inner">
                                <div class="row form-modal">
                                    <div class="d-flex justify-right">
                                        <button @click="onCloseMap" v-bind:class="'mr-5  btn btn-default close-button'">
                                        X
                                    </button>
                                    </div>
                                    <div v-if="houseSingleLocation" class="map-show">
                                        <multiLocation/>
                                    </div>
                                    <div v-if="!houseSingleLocation" class="text-center">
                                        No records Found
                                    </div>
                                    <div class="d-flex justify-right">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    
                <v-server-table ref="housesTable" url :limit="5" :columns="columns" :options="options" @loaded="onLoaded">
                    <template slot="beforeBody">
                        <tr v-if="loading" class="VueTables__no-results">
                            <td class="text-center" colspan="6">
                                <pulse-loader></pulse-loader>
                            </td>
                        </tr>
                    </template>
    
                    <template slot="action" slot-scope="props">
                        <div class="d-flex">
                            <div class="active_wrp">
                                <a class="fa fa-edit" role="button" v-on:click.stop="action(props.row)"></a>
                            </div>
                            <div class="active_wrp" v-on:click.stop="houseLocationOnMap(props.row)" v-bind:style="{cursor: 'pointer'}">
                                <a class="fa fa-map-marker" v-tooltip.hover title="No Lat Lng Available" role="button" v-bind:style="{
                                    'pointer-events': props.row.geoLoc === '--' ? 'visible' : 'none',
                                }"></a>
                            </div>
                            <div class="active_wrp" v-on:click.stop="viewImage(props.row)" v-bind:style="{cursor: 'pointer'}">
                        <a class="fa fa-eye" role="button" v-tooltip.hover title="No Image Available" v-bind:style="{
                    'pointer-events':
                      props.row.houseImage == 'null' ||
                      props.row.houseImage == null ||
                      props.row.houseImage == ''
                        ? 'visible'
                        : 'none',
                  }">
                            
                        </a>
                            </div>
                        </div>
                    </template>
                </v-server-table>
                <div>
                    <vue-easy-lightbox escDisabled moveDisabled :visible="visible" :imgs="imgs" :index="index" @hide="handleHide"></vue-easy-lightbox>
                </div>
            </div>
        </div>
    </section>
    </template>
    
    <script>
    import {
        formService,
        eventBus,
        wasteCollectionAreaService,
        housesService
    } from "../../../services";
    import {
        USER_ROLES
    } from "../../../config";
    import {
        ServerTable,
        Event
    } from "vue-tables-2";
    import {
        mapState
    } from "vuex";
    
    import store from "../../../store";
    import swal from "sweetalert2";
    import VueEasyLightbox from 'vue-easy-lightbox';
    import multiLocation from "../gmapLocation/multiLocation";
    
    export default {
        name: "houseList",
        components: {
            VueEasyLightbox,
            multiLocation
        },
        data() {
            return {
                loading: null,
                houseSingleLocation:true,
                isSingleMap: false,
                geoData: "",
                houseListTable: null,
                USER_ROLES: USER_ROLES,
                updatehouseDetails: false,
                wasteCollectionAreaCreateTable: null,
                collectionData: {},
                index: 0,
                house: {
                    houseStatus: ""
                },
                houseStatus: ['Active', 'Inactive'],
                formstate: {},
                id: "",
                houseType: [],
                selectedType: [],
                imgs: '',
                visible: false,
                columns: [
                    "lineTowerName",
                    "hnNo",
                    "houseTag",
                    "contactPerson",
                    "contact",
                    "memberCount",
                    "houseStatus",
                    "action",
                ],
                // custom_filter_options: ['Active', 'Inactive','status'],
                // custom_filter_select: '',
                options: {
                    highlightMatches: true,
                    headings: {
                        lineTowerName: "Line / Tower",
                        hnNo: "HNO",
                        houseTag: "Tag",
                        contactPerson: "Contact Person",
                        contact: "Contact",
                        memberCount: "Family",
                        houseStatus: "Survey Status",
                        action: "Action",
                    },
                    perPage: 10,
                    sortable: ["lineTowerName", "hnNo","houseTag","contactPerson","contact", "memberCount"],
                    requestFunction: (request) => {
                        const params = {};
                        params._id = this.$route.params._id;
                        params.page = request.page;
                        params.limit = request.limit;
                        //   params.sortBy= 'createdAt'
                        //   params.sortOrder= 'des'        
    
                        if (request.orderBy) {                        
                            if (request.orderBy == 'hnNo') {
                                params.sortBy = 'houses.hnNo';
                            }else if(request.orderBy == "geoLoc"){
                                params.sortBy = "houses.geoLoc"; 
                            }else if(request.orderBy == "houseTag"){
                                params.sortBy = "houses.houseTag"; 
                            }else if (request.orderBy == 'contact') {
                                params.sortBy = 'houses.contact';
                            } else if (request.orderBy == 'memberCount') {
                                params.sortBy = 'houses.memberCount';
                            } else if (request.orderBy == 'contactPerson') {
                                params.sortBy = 'houses.contactPerson';
                            } else if (request.orderBy == 'lineTowerName') {
                                params.sortBy = 'name';
                            } else {
                                params.sortBy = request.orderBy;
                            }
    
                            if (request.ascending == 1) {
                                params.sortOrder = "asc";
                            } else {
                                params.sortOrder = "des";
                            }
                        }    
                        if (request.query != "") {
                            params.searchString = request.query;
                        }
                        this.loading = true;
                        return this.$houseByIdDataRepository
                            .getList(params)
                            .catch((error) => {});
                    },
    
                    responseAdapter: (response) => {
                        this.loading = false;
                        let houseList = [];
                        response.data.response.forEach((element) => {
                            let houseInfo = element.houses;
                            houseInfo['lineTowerName'] = element.name;
                            houseInfo['hnNo'] = element.houses.hnNo;
                            houseInfo['contact'] = element.houses.contact ? element.houses.contact : "--";
                            houseInfo['houseTag'] = element.houses.houseTag ? element.houses.houseTag : "--";
                            houseInfo['geoLoc'] = element.houses.geoLoc != "" ? element.houses.geoLoc.reverse().join(",") : "--";
                            houseInfo['contactPerson'] = element.houses.contactPerson ? element.houses.contactPerson : "--";
                            houseInfo['hnId'] = element.houses._id;
                            houseList.push(houseInfo);
                        })
                        return {
                            data: houseList,
                            count: response.data.totalCount,
                        };
                    },
    
                    customFilters: [{
                        name: "custom_filter",
                        callback: function (row, query) {
                            //	return row.role[0] == query;
                        },
                    }, ],
                    uniqueKey: "_id",
                },
            };
        },
        computed: {
            addButtonClass() {
                if (this.houseListTable) {
                    return this.houseListTable.count >
                        this.houseListTable.limit ||
                        this.houseListTable.limit > 10 ?
                        "shift-add-left" :
                        "add-item";
                } else {
                    return "add-item";
                }
            },
            // ...mapState({
            //   user: (state) => state.auth.user,
            // }),
        },
        methods: {
            fieldClassName: formService.fieldClassName,
            onLoaded() {
                this.houseListTable = this.$refs.houseListTable;
            },
            clearFilter() {
                this.custom_filter_select = "";
            },
            onClose() {
                this.updatehouseDetails = false;
            },
            houseLocationOnMap(data){
                if(data.geoLoc != '--'){
                    this.isSingleMap = true;
                    let housesInfo = [];
                    let geoData = JSON.parse("[" + data.geoLoc + "]");
                    if(geoData.length > 0){
                        let house = data;
                        house['lat'] = geoData[0]
                        house['lng'] = geoData[1]
                        housesInfo.push(house)
                    }
                    if(housesInfo.length > 0){
                        this.houseSingleLocation = true;
                        eventBus.$off("houseZoneEvent");
                        eventBus.$on("houseZoneEvent", ()=> {
                            eventBus.$emit("housesLocation", housesInfo);
                        });
                    } else{
                        this.houseSingleLocation = false;
                    }   
                }
            },
            onCloseMap(){
                this.isSingleMap = false
            },
            updateHouseInfo() {
                this.house['familyMembers'] = this.house.memberCount.toString()
                if (this.house.houseTag == null || this.house.houseTag == '') {
                    delete this.house.houseTag;
                }
                if (this.house.contact == '') {
                    delete this.house.contact;
                }
                this.house['geoLoc'] = []
                this.house['geoLoc'][1] = parseFloat(this.house.latitude)
                this.house['geoLoc'][0] = parseFloat(this.house.longitude)
                return housesService.updateHouse(this.house).then((response) => {
                        this.updatehouseDetails = false;
                        this.$snotify.success('House Updated Successfully', 'success!');
                        this.$refs.housesTable.refresh()
                    })
                    .catch(error => {
                        this.loading = false;
                        this.$snotify.error(error.message, 'Error!');
                    });
            },
    
            action(data) {
                this.updatehouseDetails = true;
                return housesService.getById(data.hnId).then((response) => {
                        this.house = response.data.response
                        if (!response.data.response.houseTypeId) {
                            this.house['houseTypeId'] = this.selectedType[0]._id
                        } else {
                            this.house['houseTypeId'] = response.data.response.houseTypeId._id
                        }
                        this.house['houseStatus'] = response.data.response.houseStatus != 'Pending' ? response.data.response.houseStatus : ''
                        if (response.data.response.geoLoc.length > 0) {
                            this.house["latitude"] =
                                response.data.response.geoLoc[1]
                            this.house["longitude"] = response.data.response.geoLoc[0];
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        this.$snotify.error(error, 'Error!');
                    });
            },
            getHouseType() {
                return housesService.getHouseType('').then((response) => {
                    response.data.response.forEach((element) => {
                        let val = {}
                        val['name'] = element.name
                        val['_id'] = element._id
                        this.houseType.push(val)
                    })
                    this.selectedType = this.houseType.filter((el) => el.name == 'Residential')
                }).catch((error) => {
                    this.$snotify.error("Get House Type list failed", "Error!");
                })
            },
            viewImage(house) {
                if (
                    !(
                        house.houseImage == "null" ||
                        house.houseImage == null ||
                        house.houseImage == ""
                    )
                ) {
                this.imgs = house.houseImage
                this.houseImageUrl = house.houseImage
                this.visible = true
                }
            },
            handleHide() {
                this.visible = false
            }
        },
        mounted() {
            this.getHouseType();
            eventBus.$on("DATA_PUBLISHED", (payload) => {});
        },
    };
    </script>
    
    <style>
    .sorting {
        position: absolute;
        left: 319px;
        z-index: 1000;
        width: 200px;
    }
    
    .box-body {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
    
    .gradientbt {
        background: #35A2FE;
        color: white;
    }
    
    .collection_division_wrp a {
        color: #35A2FE;
        margin-right: 30px;
    }
    
    .collection_division_wrp {
        display: flex;
        align-items: center;
    }
    
    .table_wrp table tr td:first-child {
        width: 105px;
    }
    
    .table_wrp table tr td {
        max-width: 100px;
    }
    
    .overlay {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
    }
    
    .editHouse {
        display: flex;
        justify-content: center;
        align-content: center;
    }
    
    .sidepop {
        position: fixed;
        width: 600px;
        z-index: 9999;
        margin: 0 auto;
        padding: 20px 30px;
        background-color: #fff;
        right: 0;
        top: 0;
        height: 100%;
    }
    
    .form-modal {
        background: #fff;
        width: 60%;
        padding: 0;
    }
    
    .text-center {
        text-align: center;
    }
    
    .overlay_inner {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
    }
    
    .overlay_inner .form-modal h4 {
        background: #f1f1f1;
        padding: 20px;
        margin: 0;
        border-bottom: 1px solid #ddd;
        text-align: left;
    }
    
    .overlay_inner .form-actions {
        text-align: right;
        padding: 20px 15px;
        border-top: 1px solid #ddd;
        display: inline-block;
        width: 100%;
    }
    
    .formadd_scroll {
        overflow: auto;
        overflow-x: hidden;
        padding: 15px 0px;
    
    }
    
    .formadd_scroll_margin {
        margin-left: -15px;
        margin-right: -15px;
    }
    
    .formadd_scroll::-webkit-scrollbar {
        width: 5px;
    }
    
    .formadd_scroll::-webkit-scrollbar-thumb {
        background: #888;
    }
    
    @media(max-width:1199px) {
        .formadd_scroll {
            height: 290px;
        }
    }
    
    @media only screen and (min-width: 1299px) {
        .table_wrp table tr td {
            max-width: 142px;
        }
    }
    
    @media only screen and (min-width: 1399px) {
        .table_wrp table tr td {
            max-width: 120px;
        }
    }

    .location .waste_type_pop .form-modal{
        width: 80% !important;
        height: 80% !important;
        padding: 10px 15px;
    }
    </style>
    


// WEBPACK FOOTER //
// houseList.vue?092e7a04